import request from '../api/request'

// 分页查询试卷
export function queryExamPaperList(param) {
  return request({
    url: '/paper/list',
    method: 'get',
    params: param
  })
}

// 根据ID查询试卷
export function queryExamPaperById(paperId) {
    return request({
      url: '/paper/' + paperId,
      method: 'get',
    })
  }

// 新增试卷
export function addPaper(data) {
    return request({
      url: '/paper/createPaper',
      method: 'post',
      data: data
    })
}

// 修改试卷
export function modifyPaper(data) {
    return request({
      url: '/paper',
      method: 'put',
      data: data
    })
}

// 删除题目
export function deleteExamPapers(paperIds) {
    return request({
      url: '/paper/'+ paperIds,
      method: 'delete',
    })
}